/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState } from 'react' // eslint-disable-line

import { Drawer, Button, Form, Spin, Input, message } from 'antd'

import { userAction } from '../../action/user'

// import { User } from '../../business/define'
import { ViewerStyles, EditorStyles } from './styles'

const FIELDS_LIST = [
  'trial_times',
  'username',
]
const FIELDS_META: any = {
  trial_times: '使用次数',
  username: '用户名',
}

interface Props {
  text: string
  record: any
  onLoadChange?: Function
}

const UserFormInner = (props: any) => {
  const { getFieldDecorator } = props.form

  const record = props['record']
  const onSubmitUser = (e: Event) => {
    e.preventDefault()
    props.form.validateFields((err: any, values: any) => {
      if (err) {
        message.warning(err.message)
        console.log('Received values of form: ', values)
      }
      props.onSubmitUser(values)
    })
  }

  return <Form layout="vertical" css={EditorStyles['edit-form']} onSubmit={onSubmitUser}>
    <Form.Item label="用户邮箱" css={EditorStyles["edit-label-title"]}>
      <span className="ant-form-text">{props.record['email']}</span>
    </Form.Item>
    {
      FIELDS_LIST.map((item) => {
        return (
          <Form.Item
            key={item}
            label={
              <span css={EditorStyles['edit-label']}>
                <span className="label-title">{FIELDS_META[item]}:</span>
                <span css={EditorStyles['edit-label-hint']}>{item}</span>
              </span>
            }
          >
            <div css={EditorStyles['edit-hint-line']}>
              {
                getFieldDecorator(item, {
                  initialValue: record[item],
                  rules: [
                    { required: false, message: `请填入正确的${FIELDS_META[item]}` },
                  ],
                })(
                  <Input placeholder={`Input ${item}`} />
                )
              }
            </div>
          </Form.Item>
        )
      })
    }
    <Form.Item>
      <Button type="primary" htmlType="submit">保存</Button>
    </Form.Item>
  </Form>
}

const UserForm = Form.create({ name: 'machine_attribute' })(UserFormInner)

export default (props: Props) => {
  const [visible, onVisibleChange] = useState(false)
  const [loading, onLoadChange] = useState(false)

  // const [attribute, onAttributeChange] = useState<any>(props.attribute)
  // const [editAttribute, onEditAttributeChange] = useState<any>(props.attribute)
  const reload = () => {
    if (props.onLoadChange) {
      props.onLoadChange()
    }
  }

  const onSubmitUser = (formData: any) => {
    userAction.editUserStatus(props.record['id'], formData)
      .then(responseData => {
        onLoadChange(false)
        reload()
        // onAttributeChange(formData)
      })
      .catch((err) => {
        onLoadChange(false)
        message.warning(err.message)
      })
  }

  return (
    <div css={EditorStyles['edit-pane']}>
      <Button onClick={onVisibleChange} size="small">{props.text}</Button>
      <Drawer
        title="编辑用户信息"
        width={420}
        visible={visible}
        onClose={() => {
          onVisibleChange(false)
        }}
      >
        <div css={ViewerStyles['drawer-container']}>
          <Spin spinning={loading}>
            <UserForm
              record={props.record}
              onSubmitUser={onSubmitUser}
            />
          </Spin>
        </div>
      </Drawer>
    </div>
  )
}